import React from "react"
import Image from "next/image"
import Link from "next/link"

type props = {
  title: string
  caption: string
  link: string
}

export const HelpCard: React.FC<props> = (props) => {
  return (
    <Link href={props.link}>
      <div className='help-card'>
        <div className='details'>
          <h4>{props.title}</h4>
          <p className='caption gray-text truncate'>{props.caption}</p>
        </div>
        <button className='btn-md-label round'>Learn more</button>
      </div>
    </Link>
  )
}
